import { DateTime } from 'luxon';

/**
 * Formats a DateTime instance to a string
 * @returns A string representing the given DateTime instance
 */
export default function quickDateTimeFormat(date: DateTime) {
  return date
    .setLocale('en-US')
    .toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS);
}
